import React from "react";

function Diagnostic() {
  return <div>Diagnostic</div>;
}

export default Diagnostic;
